import { api } from '@/lib/api/client'
import type { CurrentTermsBundlePayload } from '@/types/legal-documents'

export type CurrentTermsPayload = CurrentTermsBundlePayload

export interface AcceptTermsPayload {
  acceptor_type: 'institution' | 'collaborator'
  acceptance: {
    terms_accepted_at: string | null
    terms_version: string | null
    terms_current_version: string
    terms_acceptance_required: boolean
  }
}

export async function fetchCurrentTerms(token: string): Promise<CurrentTermsBundlePayload> {
  return api.get<CurrentTermsBundlePayload>('/api/institution/terms', {
    token,
    requireAuth: true,
  })
}

export async function acceptTerms(
  token: string,
  confirmationPhrase: string
): Promise<AcceptTermsPayload> {
  return api.post<AcceptTermsPayload>(
    '/api/institution/terms/accept',
    { confirmation_phrase: confirmationPhrase },
    { token, requireAuth: true }
  )
}
